<template>
	<a v-if="toast" href @mouseover="pause(toast)" @mouseout="resume(toast)" @click.prevent="handleClick(toast)" :key="`toast-${ toast.id }`" class="alert active" :class="`${ toast.type }`">{{ toast.message }}<span class="fa" :class="toast.icon"></span></a>
</template>

<script>

import { mapGetters } from 'vuex';

export default {

	computed: {

		...mapGetters([ 'toasts' ]),

		toast() {
			return this.toasts[this.toasts.length - 1];
		},

	},

	methods: {

		pause(toast) {
			this.$store.dispatch('pauseToast', toast.id);
		},

		resume(toast) {
			this.$store.dispatch('resumeToast', toast.id);
		},

		handleClick(toast) {
			toast.onClick();
		},

	}
};

</script>
